import { Button } from "@/components/ui/button";
import { useBuyerNotifications } from "@/hooks/useBuyerNotifications";
import { formatDistanceToNow } from "date-fns";
import { useNavigate } from "react-router-dom";

const BuyerNotificationDropdown = () => {
  const navigate = useNavigate();
  const { notifications, markAsRead, markAllAsRead } = useBuyerNotifications();
  
  const recentNotifications = notifications.slice(0, 5);
  const hasUnreadNotifications = notifications.some(n => !n.read_status);

  const handleNotificationClick = async (notification: any) => {
    if (!notification.read_status) {
      await markAsRead(notification.id);
    }
    
    // Navigate to property if notification has property_id
    if (notification.content?.property_id) {
      navigate(`/buyer/properties/${notification.content.property_id}`);
    }
  };

  if (notifications.length === 0) {
    return (
      <div className="p-4 text-center text-muted-foreground">
        No notifications yet
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between p-3 border-b">
        <span className="font-medium">Notifications</span>
        {hasUnreadNotifications && (
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={markAllAsRead}
            className="text-xs"
          >
            Mark all read
          </Button>
        )}
      </div>
      
      <div className="max-h-80 overflow-y-auto">
        {recentNotifications.map((notification) => (
          <div
            key={notification.id}
            className={`p-3 border-b cursor-pointer hover:bg-muted/50 transition-colors ${
              !notification.read_status ? 'bg-muted/30' : ''
            }`}
            onClick={() => handleNotificationClick(notification)}
          >
            <div className="space-y-1">
              <p className="text-sm font-medium">
                {notification.content?.title || 'New Notification'}
              </p>
              {notification.content?.message && (
                <p className="text-xs text-muted-foreground">
                  {notification.content.message}
                </p>
              )}
              <p className="text-xs text-muted-foreground">
                {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })}
              </p>
            </div>
          </div>
        ))}
      </div>
      
      {notifications.length > 5 && (
        <div className="p-3 border-t">
          <Button 
            variant="ghost" 
            size="sm" 
            className="w-full text-xs"
            onClick={() => navigate('/buyer/notifications')}
          >
            View all notifications
          </Button>
        </div>
      )}
    </div>
  );
};

export default BuyerNotificationDropdown;